module.exports = __webpack_public_path__ + "static/img/16.ee83edc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/16.png
// module id = GcKB
// module chunks = 1